const getters = {
  getStateMini: (state) => state.isMini,
  getStateMenu: (state) => state.showMenu,
  getStateLoading: (state) => state.showLoading
};

export default getters;
